import React from "react";
import { Form } from "react-bootstrap";
import { Col } from "reactstrap";

const CourierStatusFilter = ({ filters, handleChange }) => {
  return (
    <Col xs="auto">
      <Form.Select
        value={filters.status || ""}
        onChange={(e) => handleChange("status", e.target.value)}
      >
        <option value="">الحالة</option>
        <option value="active">نشط</option>
        <option value="inactive">غير نشط</option>
        <option value="blocked">محظور</option>
      </Form.Select>
    </Col>
  );
};

export default CourierStatusFilter;